// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh; /* Adjust this as needed */
}
:host {
  font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}
mat-spinner {
  margin: auto;
  position: absolute; /* Add this line */
  top: 50%; /* Add this line */
  left: 50%; /* Add this line */
  transform: translate(-50%, -50%); /* Add this line */
}
.material-table-scrollbar {
  overflow: visible;
  height: auto;
}
.searchFilter{
  display: grid;
  padding-bottom: 10px;
}

.center-content {
  margin: auto !important;
  text-align: center;
}
.container{
  width:100%;
 background-color: white;
 font-weight: bold;
}
.bold-text{
font-weight: bold;
font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

}
.sub-container1{
width:100%;
border:2px solid rgb(230, 225, 225);
background-color:rgb(240, 240, 240);
border-radius:10px;
margin:0%;
padding-left: 2%;
padding-right: 2%;
padding: 2%;
}
.sub-container2{
  width:100%;
  border:2px solid  #286090;
  border-radius:10px;
  margin:2% 0%;
}
.select-text
{
    color:white;
    background-color: #286090;
    border-radius: 5px 5px 0 0;
    text-align: left;
    padding-left:1%;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.table-padding{
  margin: 1%;
}
`, "",{"version":3,"sources":["webpack://./src/app/search/permanent-doa/searchpermanentdoa.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,0BAA0B;AAC3C;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,YAAY;EACZ,kBAAkB,EAAE,kBAAkB;EACtC,QAAQ,EAAE,kBAAkB;EAC5B,SAAS,EAAE,kBAAkB;EAC7B,gCAAgC,EAAE,kBAAkB;AACtD;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,UAAU;CACX,uBAAuB;CACvB,iBAAiB;AAClB;AACA;AACA,iBAAiB;AACjB,2DAA2D;;AAE3D;AACA;AACA,UAAU;AACV,mCAAmC;AACnC,mCAAmC;AACnC,kBAAkB;AAClB,SAAS;AACT,gBAAgB;AAChB,iBAAiB;AACjB,WAAW;AACX;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,2DAA2D;AAC/D;AACA;EACE,UAAU;AACZ","sourcesContent":[".spinner-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh; /* Adjust this as needed */\n}\n:host {\n  font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}\nmat-spinner {\n  margin: auto;\n  position: absolute; /* Add this line */\n  top: 50%; /* Add this line */\n  left: 50%; /* Add this line */\n  transform: translate(-50%, -50%); /* Add this line */\n}\n.material-table-scrollbar {\n  overflow: visible;\n  height: auto;\n}\n.searchFilter{\n  display: grid;\n  padding-bottom: 10px;\n}\n\n.center-content {\n  margin: auto !important;\n  text-align: center;\n}\n.container{\n  width:100%;\n background-color: white;\n font-weight: bold;\n}\n.bold-text{\nfont-weight: bold;\nfont-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n}\n.sub-container1{\nwidth:100%;\nborder:2px solid rgb(230, 225, 225);\nbackground-color:rgb(240, 240, 240);\nborder-radius:10px;\nmargin:0%;\npadding-left: 2%;\npadding-right: 2%;\npadding: 2%;\n}\n.sub-container2{\n  width:100%;\n  border:2px solid  #286090;\n  border-radius:10px;\n  margin:2% 0%;\n}\n.select-text\n{\n    color:white;\n    background-color: #286090;\n    border-radius: 5px 5px 0 0;\n    text-align: left;\n    padding-left:1%;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.table-padding{\n  margin: 1%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
